import Vue from 'vue';
import { mapState } from 'vuex';
import { schemaMixin } from '@witkac/vuetify-components';

import { notificationsMixin } from './notifications';

/**
 * Mixin zarządzania modelem
 *
 * @export
 * @param {string} moduleName - nazwa modułu
 * @param {Object} messages - treści notyfikacji
 * @param {string} [messages.formError] - treść notyfikacji o błędzie walidacji
 * @param {function} emptyModel - funkcja tworząca pusty model
 * @returns
 */
export function manageMixin(moduleName, messages, emptyModel) {
  return {
    mixins: [schemaMixin, notificationsMixin],
    data() {
      return {
        model: emptyModel.call(this)
      };
    },
    props: {
      // Boolean kontrolujący widoczność modala
      show: {
        type: Boolean,
        required: true,
        default: false
      },
      // Identyfikator edytowanej encji
      id: {
        type: Number,
        required: false,
        default: undefined
      }
    },
    methods: {
      /**
       * Potwierdzenie zamknięcia formularza w przypadku zmian
       */
      close() {
        if (this.$schema.$dirtyList().length !== 0) {
          this.$store.dispatch('showConfirmDialog');
        } else {
          this.closeModal();
        }
      },
      // @vuese
      // Funkcja emituje event `close` do zamknięcia modalu
      closeModal() {
        // Zamyka modal
        this.$emit('close');
      },
      // @vuese
      // Funkcja waliduje formularz, i zapisuje/nadpisuje dane w bazie
      save() {
        if (!this.$schema.$validateAll().length) {
          if (this.id) {
            this.update();
          } else {
            this.add();
          }
        } else {
          this.notifyError(messages.formError || 'Błędnie wypełniony formularz.');
        }
      },
      // @vuese
      // Emituje event do zapisu danych
      add() {
        // Emituje event do zapisu danych
        // @arg Zwalidowany model do utworzenia w bazie
        this.$emit('save', this.model);
      },

      // @vuese
      // Emituje event do edytowania danych
      update() {
        // Emituje event do edytowania danych
        // @arg Zwalidowany model do edycji w bazie
        this.$emit('update', {
          id: this.getId(),
          ...this.model
        });
      },

      /**
       * Pobiera identyfikator encji
       */
      getId() {
        return parseInt(this.id);
      },

      /**
       * Ustawia dane formularza
       */
      setData() {
        this.$schema.$setData(this.id ? this.stateData : emptyModel.call(this), undefined, true);
        this.$schema.$reset();
      }
    },
    computed: mapState({
      stateData: state => {
        const data = state[moduleName].data;
        for (const key of Object.keys(data)) {
          if (data[key] === null) {
            Vue.delete(data, key);
          }
        }
        return data;
      },
      confirm: state => state.modalClose.confirm
    }),
    watch: {
      /**
       * Resetuje pola modala przed pokazaniem go
       *
       * @param {boolean} val
       */
      show(val) {
        if (val) {
          this.setData();
        }
      },
      confirm(val) {
        if (val) {
          this.closeModal();
          this.$store.dispatch('resetConfirmState');
        }
      }
    }
  };
}
